import { call, put, takeLatest } from "redux-saga/effects";
import { Action } from "../../../actions/actions";
import { API } from "../../../api/api";
import { ConfigurationsActionTypes } from "../actions/actionTypes";
import { configurationsAPI } from "../api/api";

function* getRegions(action: Action) {
    try {
        const regions = yield call(() =>
            configurationsAPI.getRegions(action.payload.subsidiary)
        );

        yield put({
            type: ConfigurationsActionTypes.GET_REGIONS_SUCCESS,
            payload: regions.data
        });
    } catch (e) {
        API.handleError(e.response, "Error getting regions.");

        yield put({
            type: ConfigurationsActionTypes.GET_REGIONS_FAIL,
            payload: e
        });
    }
}

export function* getRegionsWatcher() {
    yield takeLatest(ConfigurationsActionTypes.GET_REGIONS, getRegions);
}
